import { jsx as e, jsxs as h } from "react/jsx-runtime";
import i from "react";
import { LinkTarget as b } from "../../types/target-link-types.js";
import { RocheUIIcon as d } from "../icon/roche-icon.js";
import { RocheUITextLink as p } from "../text-link/roche-text-link.js";
import { RocheUITextLinkType as o } from "../text-link/roche-text-link.types.js";
import c from "./roche-breadcrumbs.module.scss.js";
const g = ({ items: a, ariaLabel: m, slot: n, onBreadcrumbClick: s }) => {
  const l = (r, t) => /* @__PURE__ */ h(i.Fragment, { children: [
    t > 0 && /* @__PURE__ */ e("span", { className: c.breadcrumbs__icon, children: /* @__PURE__ */ e(d, { icon: "chevron-right", height: "14px" }) }),
    /* @__PURE__ */ e("li", { className: c.breadcrumbs__item, children: r.href ? /* @__PURE__ */ e(
      p,
      {
        href: r.href,
        text: r.text,
        target: b.SELF,
        type: o.BREADCRUMBS,
        onTextLinkClick: () => s(o.BREADCRUMBS, r.text, r.href)
      }
    ) : /* @__PURE__ */ e("p", { className: c.breadcrumbs__text, children: r.text }) })
  ] }, `breadcrumb-${t}`);
  return /* @__PURE__ */ e("nav", { className: c.breadcrumbs, "aria-label": m, slot: n, children: /* @__PURE__ */ e("ol", { className: c["breadcrumbs__item-list"], children: a == null ? void 0 : a.map((r, t) => l(r, t)) }) });
};
export {
  g as RocheUIBreadcrumbs
};
